import {
  Action,
  deleteInvocesToken,
  domen,
  reloadSaveStatuses,
  saveToken,
  Trigger,
} from '../../defaults';

export const deleteExistedTriggers: Trigger[] = [
  {
    events: ['on-change-any-data-param'],
    targets: [saveToken],
    handlers: ['add-save-delete-requests', 'delete-existed', 'add-invoces-pending'],
    expr: {
      type: 'func',
      value: `({hashMap}) => hashMap['${saveToken}'].data.customData.saveStatus === 'valid' 
    && !hashMap['${saveToken}'].data.customData['${reloadSaveStatuses['save-delete']}']  
    && !!hashMap['${deleteInvocesToken}'].data.value.length`,
    },
  },

  {
    events: ['data-fetch-success'],
    targets: [saveToken],
    handlers: [
      'saveStatus-to-save-delete',
      'remove-save-delete-requests',
      'subtract-invoces-pending',
    ],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'delete-existed'`,
    },
  },

  {
    events: ['data-fetch-error'],
    targets: [saveToken],
    handlers: [
      'remove-save-delete-requests',
      'subtract-invoces-pending',
      'show-modal-error',
    ],
    expr: {
      type: 'func',
      value: `({sourceAction}) => sourceAction.token === 'delete-existed'`,
    },
  },
];

export const deleteExistedActions: Action[] = [
  {
    kind: 'changes',
    token: 'add-save-delete-requests',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['save-delete']}`]: {
          type: 'val',
          value: true,
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'remove-save-delete-requests',
    spec: {
      target: saveToken,
      changes: {
        [`data.customData.${reloadSaveStatuses['save-delete']}`]: {
          type: 'val',
          value: false,
        },
      },
    },
  },

  {
    kind: 'api',
    token: 'delete-existed',

    spec: {
      uri: `${domen}/v1/tck/bms/invoices/delete-batch`,
      method: 'POST',
      ignoreCanceledRequest: true,
      data: {
        app: {
          type: 'func',
          value: '({config}) => config.custom.app',
        },
        token: {
          type: 'func',
          value: '({config}) => config.custom.token',
        },
        timezone: {
          type: 'func',
          value: '({config}) => config.custom.timezone',
        },
        ids: {
          type: 'func',
          value: `({hashMap}) => hashMap['${deleteInvocesToken}'].data.value`,
        },
      },
    },
  },

  {
    kind: 'changes',
    token: 'saveStatus-to-save-delete',
    spec: {
      target: saveToken,
      changes: {
        'data.customData.saveStatus': {
          type: 'val',
          value: reloadSaveStatuses['save-delete'],
        },
      },
    },
  },
];
